var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "#F6F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.038 13.7887C23.0442 13.9295 23.0442 14.0639 23.0442 14.2047C23.0504 18.4735 19.9141 23.4016 14.1786 23.4016C12.4869 23.4016 10.8262 22.896 9.40002 21.9488C9.64698 21.9808 9.89393 21.9936 10.1409 21.9936C11.5423 21.9936 12.9068 21.5072 14.0119 20.6048C12.6783 20.5792 11.5053 19.6768 11.0978 18.3583C11.567 18.4543 12.0486 18.4351 12.5055 18.3007C11.0546 18.0063 10.0112 16.6815 10.0051 15.1391C10.0051 15.1263 10.0051 15.1135 10.0051 15.1007C10.4372 15.3503 10.925 15.4911 11.4189 15.5039C10.0545 14.5567 9.62846 12.6687 10.4558 11.1903C12.0424 13.2127 14.3761 14.4351 16.8827 14.5695C16.6296 13.4495 16.9753 12.2719 17.7841 11.4783C19.0374 10.2559 21.013 10.3199 22.1984 11.6191C22.896 11.4783 23.569 11.2095 24.1802 10.8319C23.9456 11.5807 23.4579 12.2143 22.8096 12.6175C23.427 12.5407 24.032 12.3679 24.6 12.1119C24.1802 12.7647 23.6493 13.3279 23.038 13.7887Z",
    fill: "#1D9BF0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterbutton);
export default __webpack_public_path__ + "static/media/Twitterbutton.930c57d9.svg";
export { ForwardRef as ReactComponent };